import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';
import { storedLocale } from 'partners/storedLocale';
import NewaieyeLogoMark from 'assets/newaieye/logoMark.svg?react';

export const newaieyeBaseUrl = `${envConfig(
  'b2BucketUrl'
)}/homeSecurity/newaieye`;

export const defaultAssets: TPartnerAssets = {
  logo: `${newaieyeBaseUrl}/logo.svg`,
  loginIllustration: `${newaieyeBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${newaieyeBaseUrl}/30DaysEventIcon.svg`,
  CannotAddSelectedCameraIcon: `${newaieyeBaseUrl}/CannotAddSelectedCamera.svg`,
  attentionIcon: `${newaieyeBaseUrl}/attention.svg`,
  basicAlertsIcon: `${newaieyeBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${newaieyeBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${newaieyeBaseUrl}/clockIcon.svg`,
  decriptiveAIAlertsIcon: `${newaieyeBaseUrl}/decriptiveAIAlertsIcon.svg`,
  firmwareVersionIcon: `${newaieyeBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${newaieyeBaseUrl}/interntNotConnected.svg`,
  limitedSecurityIcon: `${newaieyeBaseUrl}/limitedSecurityIcon.svg`,
  locationIcon: `${newaieyeBaseUrl}/location.svg`,
  logoContrastIcon: `${newaieyeBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${newaieyeBaseUrl}/logoWhite.svg`,
  logoMarkIcon: NewaieyeLogoMark,
  maxCameraLimitReachedIcon: `${newaieyeBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${newaieyeBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosIcon: `${newaieyeBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${newaieyeBaseUrl}/paymentFailedIcon.svg`,
  DownGradeConfirmationIcon: `${newaieyeBaseUrl}/DownGradeConfirmation.svg`,
  paymentSuccessfulIcon: `${newaieyeBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${newaieyeBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${newaieyeBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${newaieyeBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${newaieyeBaseUrl}/professionMonitoringIcons.svg`,
  sampleCreditCardIcon: `${newaieyeBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${newaieyeBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${newaieyeBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${newaieyeBaseUrl}/wifiIcon.svg`,
  appQRCodeAndroid: `${newaieyeBaseUrl}/qrCodeAndroid.png`,
  appQRCodeIos: `${newaieyeBaseUrl}/qrCodeIos.png`,
  motionAlertsIcon: `${newaieyeBaseUrl}/motionAlerts.png`,
  snapshotIcon: `${newaieyeBaseUrl}/snapshotIcon.png`,
  liveViewIcon: `${newaieyeBaseUrl}/liveViewIcon.png`,
  dataIcon: `${newaieyeBaseUrl}/dataIcon.png`,
  noDataIcon: `${newaieyeBaseUrl}/noDataIcon.png`,
  autoDataRechargeDisabled: `${newaieyeBaseUrl}/autoDataRechargeDisabled.png`,
};

// 2️⃣ Locale-specific overrides
const localeOverrides: Record<string, Partial<TPartnerAssets>> = {
  es: {
    basicMotionAlertsImg: `${newaieyeBaseUrl}/basicMotionAlerts-es.png`
  }
};

// 3️⃣ Merge default with overrides
export const getAssetsForLocale = (locale: string): TPartnerAssets => {
  return {
    ...defaultAssets,
    ...localeOverrides[locale]
  };
};

const locale = storedLocale();

export const assets = getAssetsForLocale(locale || 'en-US');
